<template>
  <div>
    <notification-sidecar
      :is-shown.sync="isNotificationShown"
      :data="listOfNotificationUsers"
    />
    <div class="m-5 p-2 flex flex-row bar-container items-center">
      <div
        v-if="selectedMenu"
        class="p-1 flex flex-col justify-center rounded-md icon-transparent-bg relative w-10 h-10 items-center icon-transparent-bg"
      >
        <img
          class="w-8"
          :src="selectedMenu.icon"
        >
      </div>
      <p
        v-if="selectedMenu"
        class="ml-5 self-center text-xl font-semibold"
      >
        {{ truncateMenuName(selectedMenu.name) }}
      </p>
      <div class="flex h-10">
        <div class="mx-3 divider" />
        <div
          v-if="$route.meta.parent"
          class="flex flex-row"
        >
          <p
            class="self-center text-xs cursor-pointer"
            @click="$router.push({ name: $route.meta.parent.name })"
          >
            {{ $route.meta.parent.title }}
          </p>
          <p class="mx-3 self-center">
            >
          </p>
          <p class="self-center text-xs font-semibold text-secondary">
            {{ $route.meta.breadcrumb }}
          </p>
        </div>
        <p
          v-else
          class="self-center text-sm font-semibold text-primary-accent"
        >
          {{ $route.meta.title }}
        </p>
      </div>
      <div class="ml-auto self-end flex flex-row justify-center">
        <div class="p-1 flex flex-col justify-center">
          <div
            class="flex relative p-1 w-10 h-10 justify-center items-center cursor-pointer icon-transparent-bg"
            @click="isNotificationShown = !isNotificationShown"
          >
            <img
              class="w-6"
              :src="require('../../assets/shipo-icon-notification.svg')"
            >
            <div class="icon-badge">
              {{ listOfNotificationUsers.length > 9 ? '9+' : listOfNotificationUsers.length }}
            </div>
          </div>
        </div>
        <div class="p-1 flex flex-col justify-center">
          <div class="flex relative w-10 h-10 justify-center items-center icon-transparent-bg">
            <vs-icon
              icon="person"
              color="#836ADA"
              class="p-1 cursor-pointer icon-transparent-bg"
              @click="isTopBarMenuShown = !isTopBarMenuShown"
            />
          </div>
        </div>
        <div class="mx-3 flex flex-col justify-center">
          <p class="font-semibold">
            {{ me.username }}
          </p>
          <p class="text-gray-500">
            {{ parseRoles }}
          </p>
        </div>
      </div>
    </div>
    <transition name="show-smooth">
      <top-bar-menu
        v-show="isTopBarMenuShown"
        :username="me.username"
        :roles="me.roles"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import NotificationSidecar from '@/components/notificationSidecar/index.vue'
import TopBarMenu from '@/components/topBarMenu'
import { INTERVAL_FETCH_NOTIFICATION } from '@/fixtures/Constants'

export default {
  components: {
    NotificationSidecar,
    TopBarMenu
  },
  data() {
    return {
      isTopBarMenuShown: false,
      isNotificationShown: false,
      listOfNotificationUsers: []
    }
  },
  computed: {
    ...mapGetters({
      me: 'Auth/me',
      userNotifications: 'UserNotifications/userNotifications',
      menuIcons: 'Auth/menuIcons'
    }),
    selectedMenu() {
      const currentPageName = this.$route.name
      return this.findParent(currentPageName, this.me.permissions)
    },
    parseRoles() {
      return this.me.roles[0]
    }
  },
  watch: {
    userNotifications: {
      handler(val) {
        this.listOfNotificationUsers = val
      }
    }
  },
  mounted() {
    this.startIntervalFetchingNotifications()
  },
  destroyed() {
    this.stopIntervalFetchingNotifications()
  },
  methods: {
    findParent(menuName) {
      const foundedMenu = this.me.permissions.find(permission => permission.url_name === menuName || permission.children.some(child => child.url_name === menuName || child.children.some(grandChild => grandChild.url_name === menuName)))
      if(foundedMenu) return {...foundedMenu, icon: foundedMenu.hasOwnProperty('icon') && typeof foundedMenu.icon === 'object' ? this.menuIcons[`${foundedMenu.id}`]?.src || foundedMenu.icon?.downloadUrl : null}
      return null
    },
    async fetchNotifications(params) {
      await this.$store.dispatch('UserNotifications/fetchNotifications', params)
    },
    truncateMenuName(name) {
      // `25` is max string length for ellipsis
      return name.length > 25 ? `${name.substring(0, 25)}...` : name
    },
    async startIntervalFetchingNotifications() {
      await this.fetchNotifications({ is_send: false })
      this.stopIntervalFetchingNotifications()

      window.notificationInterval = setInterval(async () => {
        await this.fetchNotifications({ is_send: false })
      }, INTERVAL_FETCH_NOTIFICATION)
    },
    stopIntervalFetchingNotifications() {
      clearInterval(window.notificationInterval)
      window.notificationInterval = undefined
    }
  }
}
</script>

<style lang="scss" scoped>
.bar-container {
  background-color: white;
  border-radius: 0.5rem;
}

.icon-transparent-bg {
  background-color: #C2B6EA;
  border-radius: 0.5rem;
}

.icon-badge {
  @apply absolute flex bg-danger justify-center items-center text-white w-4 h-4 rounded-full;

  font-size: 0.65rem;
  top: -0.38rem;
  left: 1.85rem;
}

.divider {
  border: solid 1px #DEDEDE;
}
</style>
